const VALID_TIERS: ReadonlySet<string> = new Set(['bronze', 'silver', 'gold', 'platinum'])

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

/** Validates that a Lab feature flag DynamicPayload is a well-formed tier upgrade campaign config. */
export function isLabTierUpgradeCampaignPayload(
  payload: unknown,
): payload is App.TierUpgradeCampaignPayload {
  if (!isObject(payload)) return false
  return (
    typeof payload.slug === 'string' &&
    typeof payload.campaignId === 'string' &&
    Array.isArray(payload.tiers) &&
    payload.tiers.length > 0 &&
    payload.tiers.every((t: unknown) => typeof t === 'string' && VALID_TIERS.has(t)) &&
    typeof payload.termsSlug === 'string' &&
    isObject(payload.partner) &&
    typeof payload.partner.name === 'string' &&
    typeof payload.partner.memberStatus === 'string' &&
    typeof payload.partner.logoImageId === 'string' &&
    isObject(payload.hero) &&
    typeof payload.hero.title === 'string' &&
    typeof payload.hero.subtitle === 'string' &&
    typeof payload.hero.imageId === 'string' &&
    (payload.secondarySection === undefined || (
      isObject(payload.secondarySection) &&
      typeof payload.secondarySection.title === 'string' &&
      typeof payload.secondarySection.subtitle === 'string'
    ))
  )
}
